import React from "react";
import PropTypes from "prop-types";
import "../css/OrderLine.css";

/*
 * Ligne commande « riche » unique, partagée par le comparateur dry-run et la simulation. Rendue à partir
 * des données du back (order_card enrichi : nom client, adresse, sacs, kg, créneau, fenêtre de livraison,
 * retard) — aucune dépendance au store dispatch, donc le nom client s'affiche TOUJOURS (jour passé
 * compris). À utiliser dans un <tbody>.
 */
const r1 = (x) => Math.round((x || 0) * 10) / 10;
// Fenêtre de livraison projetée « au plus tôt–au plus tard » (valeur seule si bornes égales).
const deliveryWindow = (o) =>
  o.eta_min ? `${o.eta_min}${o.eta_max && o.eta_max !== o.eta_min ? `–${o.eta_max}` : ""}` : "";

export function OrderLine({ order: o }) {
  return (
    <tr className="OrderLine">
      <td className="OrderLine-ref">#{o.ref}</td>
      <td className="OrderLine-client" title={o.client}>{o.client || "—"}</td>
      <td className="OrderLine-addr" title={`${o.address || ""} ${o.postal_code || ""}`}>
        {o.address ? `${o.address} · ` : ""}{o.postal_code}
      </td>
      <td className="OrderLine-type">{o.type ? <span className="OrderLine-badge">{o.type}</span> : null}</td>
      <td className="OrderLine-num">{o.bags} sac{o.bags > 1 ? "s" : ""}</td>
      <td className="OrderLine-num">{r1(o.weight_kg)} kg</td>
      <td className="OrderLine-slot">{o.slot_start ? `créneau ${o.slot_start}–${o.slot_end}` : ""}</td>
      <td className="OrderLine-eta">{deliveryWindow(o) ? `livr. ${deliveryWindow(o)}` : ""}</td>
      <td className="OrderLine-delay">{o.delay_min > 0 ? <span className="OrderLine-late">retard {r1(o.delay_min)}m</span> : ""}</td>
    </tr>
  );
}
OrderLine.propTypes = { order: PropTypes.object };
